<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="transit.name"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="bold-text main-color">
          Nom
        </div>
        <div class="mt-2">
          {{ transit.name }}
        </div>
        <div class="mt-4 bold-text main-color">
          Description
        </div>
        <div class="multiline" v-if="transit.description">
          {{ transit.description }}
        </div>
        <div v-else>
          N/A
        </div>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <transit-delete-modal :selectedTransit="ui.selectedTransit" @didDeleteTransit="didDeleteTransit()"></transit-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import TransitDeleteModal from "./TransitDeleteModal";

export default {

  name: 'TransitShow',

  components: {
    BackArrow,
    ShowActions,
    TransitDeleteModal
  },

  data() {
    return {
      transitId: this.$route.params.transitId,
      transit: null,
      ui: {
        selectedTransit: null
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchTransit()
    },

    fetchTransit() {
      api
        .get(`/transit/${this.transitId}`)
        .then(response => {
          this.transit = response.data
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'TransitEdit',
        params: {
          transitId: this.transit.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.ui.selectedTransit = this.transit
      this.$bvModal.show('transit-delete-modal')
    },

    didDeleteTransit() {
      this.ui.selectedCategory = null;
      this.$router.push({
        name: 'TransitIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`Transit \"${this.transit.name}\" supprimé`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/transit/TransitShow.vue